import { FooterCSSStyleImpl } from './footercss';
import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { FooterViewImpl } from './footerview';
import { UIComponentCSSStyle } from '../uicomponentcss';
// import { FooterAPIModelImpl } from './footerapimodel';
import { FooterAPIModelImpl } from './footerapimodel';
import { APIModelHandler, APIModel } from '../uicomponentapimodel';

export interface FooterComponentProps extends UIComponentProps
{
    isRTL?:boolean;
    onFaqClicked(): void;
    onTermsandConditionClicked():void;
    onMTNHomeClicked():void;
}

export interface FooterComponentState extends UIComponentState
{
    

}

export interface FooterComponentHandler extends UIComponentHandler{
   
}
export class FooterComponent extends UIComponentImpl<FooterComponentProps, FooterComponentState, UIDataModel> implements FooterComponentHandler
{
    constructor(props: FooterComponentProps)
    {
        super(props);
      
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FooterViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FooterCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new FooterAPIModelImpl(applicationContext, apiModelHandler);
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/footer-native/footercomponent.tsx